package wah.public

object Config {
    val apiLocation = js("WAH_API_LOCATION").unsafeCast<String>()
}